import React from 'react';
import "../css/PlanStat.css";

const PlanStat = () => {
  return (
    <div className="tour-container">
      <div className="style-F">
        <h6 className='text-white text-start'>Design Your Dream Space 🏡</h6>
        <br />
        <div className="h">
          <h1 className='text-start text-white'>Building the future, one brick at a time!</h1>
        </div>
      </div>
      <br />
      <a href="/contact-us">
        <button className="button text-black">  BOOK HOME/PLOT NOW ✅</button>
      </a>
    </div>
  );
}

export default PlanStat;
